/*
stats about Spanish syllables
generated from one of the spanishPhonotactics tests
*/

export const spanishSyllableCounts = {
  1: 355,
  2: 17829,
  3: 95342,
  4: 195751,
  5: 179727,
  6: 83637,
  7: 20391,
  8: 2550,
  9: 174,
  10: 7
}

export const spanishOnsets = {
  '': 471663, ɾ: 261662, s: 221336, t: 212270, m: 175063, k: 157681, l: 152564, d: 147152, n: 116285, β: 108232,
  p: 96498, ð: 91610, r: 78736, x: 44893, f: 43540, b: 37612, tɾ: 37450, ɣ: 34757, ʎ: 26760, tʃ: 21627, pɾ: 18332,
  g: 17145, ɲ: 12451, βɾ: 10373, pl: 9995, kɾ: 8278, ɣɾ: 7170, fɾ: 6712, bɾ: 6593, ʝ: 6422, βl: 6129, kl: 5201,
  ðɾ: 4257, fl: 4095, gɾ: 3691, dɾ: 2406, bl: 1441, gl: 1182, ɣl: 971, tl: 38
}

export const spanishNuclei = {
  a: 949150, e: 706217, o: 436052, i: 380123, u: 104512, ja: 28693, je: 27873, jo: 18941, wa: 9703, we: 5023, wi: 2577, wo: 398,
  ju: 382, aw: 194, '': 170, ej: 74, ew: 54, ij: 36, aj: 30, oj: 28, iw: 27, ow: 7, wej: 4, uj: 3, waj: 2
}

export const spanishCodas = {
  '': 1744792, s: 402691, n: 196200, ɾ: 96730, m: 52449, ŋ: 35053, ns: 27182, z: 26558, l: 26499, ks: 13793, ɾs: 11429,
  ð: 10012, k: 6882, ɲ: 4409, ls: 3407, ss: 2500, ɣ: 2480, p: 2242, βs: 1748, β: 1382, nz: 724, ps: 684, t: 181, ðs: 90,
  f: 64, ɣs: 55, g: 17, ts: 9, x: 6, xs: 2, ms: 2, r: 1
}

export const spanishFirstOnsets = {
  '': 220059, d: 81669, r: 48702, k: 41378, s: 35871, m: 27326, p: 24059, b: 22507, t: 13333, tɾ: 11821, pɾ: 11034, l: 11022,
  f: 10869, x: 6019, g: 5845, n: 4800, tʃ: 3998, fɾ: 2691, pl: 2230, kɾ: 1888, gɾ: 1620, bɾ: 1541, fl: 1332, kl: 1163, ʎ: 1008, bl: 635, gl: 542, dɾ: 425, ʝ: 362, ɲ: 10, tl: 4
}

export const spanishOtherOnsets = {
  ɾ: 261662, '': 251604, t: 198937, s: 185465, m: 147737, l: 141542, k: 116303, n: 111485, β: 108232, ð: 91610, p: 72439,
  d: 65483, x: 38874, ɣ: 34757, f: 32671, r: 30034, ʎ: 25752, tɾ: 25629, tʃ: 17629, b: 15105, ɲ: 12441, g: 11300, βɾ: 10373,
  pl: 7765, pɾ: 7298, ɣɾ: 7170, kɾ: 6390, βl: 6129, ʝ: 6060, bɾ: 5052, ðɾ: 4257, kl: 4038, fɾ: 4021, fl: 2763, gɾ: 2071,
  dɾ: 1981, ɣl: 971, bl: 806, gl: 640, tl: 34
}

export const spanishLastCodas = {
  s: 295994, '': 204681, n: 74379, ɾ: 10573, ð: 8761, l: 1238, m: 30, t: 29, ks: 28, k: 9, β: 7, x: 6, ps: 5,
  ts: 4, p: 4, ɣ: 4, ls: 4, f: 4, ɾs: 1, ðs: 1, ns: 1
}

export const spanishOtherCodas = {
  '': 1540111, n: 121821, s: 106697, ɾ: 86157, m: 52419, ŋ: 35053, ns: 27181, z: 26558, l: 25261, ks: 13765, ɾs: 11428,
  k: 6873, ɲ: 4409, ls: 3403, ss: 2500, ɣ: 2476, p: 2238, βs: 1748, β: 1375, ð: 1251, nz: 724, ps: 679, t: 152, ðs: 89,
  f: 60, ɣs: 55, g: 17, ts: 5, xs: 2, ms: 2, r: 1
}
